/**
 *
 * @export
 * @interface OrgServiceAccessDeniedErrorResponseDto
 */
export interface OrgServiceAccessDeniedErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceAccessDeniedErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAccessDeniedErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAccessDeniedErrorResponseDto
   */
  reason?: string;
}
/**
 *
 * @export
 * @interface OrgServiceAddAddonSubscriptionDataDto
 */
export interface OrgServiceAddAddonSubscriptionDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddAddonSubscriptionDataDto
   */
  subscriptionId?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddAddonSubscriptionDataDto
   */
  addonId?: number;
}
/**
 *
 * @export
 * @interface OrgServiceAddMemberDataDto
 */
export interface OrgServiceAddMemberDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddMemberDataDto
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddMemberDataDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddMemberDataDto
   */
  username?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddMemberDataDto
   */
  memberTTL?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddMemberDataDto
   */
  portalUrl?: string;
}
/**
 *
 * @export
 * @interface OrgServiceAddMemberResponseDto
 */
export interface OrgServiceAddMemberResponseDto {
  /**
   * This parameter makes sense only for result=invite and shows whether invite has been created or just existing invite was returned
   * @type {boolean}
   * @memberof OrgServiceAddMemberResponseDto
   */
  inviteAlreadyExists?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddMemberResponseDto
   */
  result: OrgServiceAddMemberResponseDtoResultEnum;
  /**
   *
   * @type {OrgServiceMemberDto}
   * @memberof OrgServiceAddMemberResponseDto
   */
  member?: OrgServiceMemberDto;
  /**
   *
   * @type {OrgServiceInviteDto}
   * @memberof OrgServiceAddMemberResponseDto
   */
  invite?: OrgServiceInviteDto;
}

export const OrgServiceAddMemberResponseDtoResultEnum = {
  Member: 'member',
  Invite: 'invite',
} as const;

export type OrgServiceAddMemberResponseDtoResultEnum =
  (typeof OrgServiceAddMemberResponseDtoResultEnum)[keyof typeof OrgServiceAddMemberResponseDtoResultEnum];

/**
 *
 * @export
 * @interface OrgServiceAddonDto
 */
export interface OrgServiceAddonDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonDto
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonDto
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  price_usd?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonDto
   */
  info?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  traffic?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  storage?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  usage?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  ocr?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  users?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  workspaces?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonDto
   */
  portals?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceAddonDto
   */
  forAllSubscriptionTypes?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceAddonDto
   */
  oneTimePurchase?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonDto
   */
  subscriptionType?: string;
}
/**
 *
 * @export
 * @interface OrgServiceAddonSubscriptionDto
 */
export interface OrgServiceAddonSubscriptionDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  subscriptionId?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  addonId?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  traffic?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  storage?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  ocr?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  members?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  workspaces?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  portals?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  forAllSubscriptionTypes?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  oneTimePurchase?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgServiceAddonSubscriptionDto
   */
  subscriptionType?: string;
}
/**
 *
 * @export
 * @interface OrgServiceApiCreateFeatureRequestDto
 */
export interface OrgServiceApiCreateFeatureRequestDto {
  /**
   *
   * @type {OrgServiceFeatureEnumDto}
   * @memberof OrgServiceApiCreateFeatureRequestDto
   */
  feature: OrgServiceFeatureEnumDto;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceApiCreateFeatureRequestDto
   */
  enabled: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceApiCreateMemberV2RequestDto
 */
export interface OrgServiceApiCreateMemberV2RequestDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceApiCreateMemberV2RequestDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceApiCreateMemberV2RequestDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceApiCreateMemberV2RequestDto
   */
  role: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceApiCreateMemberV2RequestDto
   */
  memberTTL?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceApiCreateMemberV2RequestDto
   */
  defaultWorkspaceRole?: string;
}
/**
 *
 * @export
 * @interface OrgServiceApiPatchFeatureRequestDto
 */
export interface OrgServiceApiPatchFeatureRequestDto {
  /**
   *
   * @type {OrgServiceFeatureEnumDto}
   * @memberof OrgServiceApiPatchFeatureRequestDto
   */
  feature?: OrgServiceFeatureEnumDto;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceApiPatchFeatureRequestDto
   */
  enabled: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceBillingInfoDto
 */
export interface OrgServiceBillingInfoDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceBillingInfoDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceBillingInfoDto
   */
  subscriptionId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceBillingInfoDto
   */
  plan?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceBillingInfoDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceBillingInfoDto
   */
  updatedAt?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof OrgServiceBillingInfoDto
   */
  inheritedFromOrgs?: Array<string>;
}
/**
 *
 * @export
 * @interface OrgServiceChangeOwnerDataDto
 */
export interface OrgServiceChangeOwnerDataDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceChangeOwnerDataDto
   */
  userId: number;
}
/**
 *
 * @export
 * @interface OrgServiceCheckAvailabilityDataDto
 */
export interface OrgServiceCheckAvailabilityDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceCheckAvailabilityDataDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCheckAvailabilityDataDto
   */
  sub?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCheckAvailabilityDataDto
   */
  domain?: string;
}
/**
 *
 * @export
 * @interface OrgServiceCloudFrontDistributionDto
 */
export interface OrgServiceCloudFrontDistributionDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  arn?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  distributionId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  cloudfrontDomain?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  deployed?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  deployedAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  deployTries?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCloudFrontDistributionDto
   */
  lastDeployError?: string;
}
/**
 *
 * @export
 * @interface OrgServiceConvertOrgDataDto
 */
export interface OrgServiceConvertOrgDataDto {
  /**
   * Org title
   * @type {string}
   * @memberof OrgServiceConvertOrgDataDto
   */
  title: string;
  /**
   * Org sub domain: {sub}.nimbusweb.com
   * @type {string}
   * @memberof OrgServiceConvertOrgDataDto
   */
  sub: string;
}
/**
 *
 * @export
 * @interface OrgServiceCountMembersDto
 */
export interface OrgServiceCountMembersDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceCountMembersDto
   */
  count?: number;
}
/**
 *
 * @export
 * @interface OrgServiceCouponDto
 */
export interface OrgServiceCouponDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceCouponDto
   */
  token?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCouponDto
   */
  members?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceCouponDto
   */
  redeemed?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCouponDto
   */
  redeemedByUserId?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCouponDto
   */
  redeemedForOrgId?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCouponDto
   */
  redeemedAt?: number;
}
/**
 *
 * @export
 * @interface OrgServiceCouponNumberByTypeDto
 */
export interface OrgServiceCouponNumberByTypeDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceCouponNumberByTypeDto
   */
  appsumo2023?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCouponNumberByTypeDto
   */
  appsumo2020?: number;
}
/**
 *
 * @export
 * @interface OrgServiceCouponsFeaturesDto
 */
export interface OrgServiceCouponsFeaturesDto {
  /**
   * Number of members per organization.
   * @type {number}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  membersPerOrg?: number;
  /**
   * Number of workspaces.
   * @type {number}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  workspaces?: number;
  /**
   * Traffic count.
   * @type {number}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  traffic?: number;
  /**
   * Amount of storage.
   * @type {number}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  storage?: number;
  /**
   * OCR count.
   * @type {number}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  ocr?: number;
  /**
   * Number of portals.
   * @type {number}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  portals?: number;
  /**
   *
   * @type {OrgServiceSubscriptionTypesDto}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  subscriptionType?: OrgServiceSubscriptionTypesDto;
  /**
   * List of privileges available for organization that redeemed specific number of coupons.
   * @type {Array<string>}
   * @memberof OrgServiceCouponsFeaturesDto
   */
  privileges?: Array<string>;
}
/**
 *
 * @export
 * @interface OrgServiceCouponsFeaturesResponseDto
 */
export interface OrgServiceCouponsFeaturesResponseDto {
  /**
   *
   * @type {OrgServiceCouponNumberByTypeDto}
   * @memberof OrgServiceCouponsFeaturesResponseDto
   */
  couponNumber?: OrgServiceCouponNumberByTypeDto;
  /**
   *
   * @type {OrgServiceCouponsFeaturesDto}
   * @memberof OrgServiceCouponsFeaturesResponseDto
   */
  features?: OrgServiceCouponsFeaturesDto;
}
/**
 *
 * @export
 * @interface OrgServiceCreateCouponDataDto
 */
export interface OrgServiceCreateCouponDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceCreateCouponDataDto
   */
  token: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceCreateCouponDataDto
   */
  members: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceCreateCouponDataDto
   */
  type?: string;
}
/**
 *
 * @export
 * @interface OrgServiceCreateOrgDataDto
 */
export interface OrgServiceCreateOrgDataDto {
  /**
   * Org title
   * @type {string}
   * @memberof OrgServiceCreateOrgDataDto
   */
  title: string;
  /**
   * Org sub domain: {sub}.nimbusweb.com
   * @type {string}
   * @memberof OrgServiceCreateOrgDataDto
   */
  sub: string;
  /**
   * Org domain
   * @type {string}
   * @memberof OrgServiceCreateOrgDataDto
   */
  domain?: string;
  /**
   * Org description
   * @type {string}
   * @memberof OrgServiceCreateOrgDataDto
   */
  description?: string;
  /**
   * How many people the user wants to collaborate with
   * @type {string}
   * @memberof OrgServiceCreateOrgDataDto
   */
  peopleToCollaborate?: string;
  /**
   * Org type
   * @type {string}
   * @memberof OrgServiceCreateOrgDataDto
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceCreateOrgDataDto
   */
  isOtherDescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceCreateOrgDataDto
   */
  domainShorter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceCreateOrgDataDto
   */
  authAllowRegistration?: boolean;
  /**
   * Whether to show the registration form in shares
   * @type {boolean}
   * @memberof OrgServiceCreateOrgDataDto
   */
  isShareAdEnabled?: boolean;
  /**
   * To initially suspend the org set true here
   * @type {boolean}
   * @memberof OrgServiceCreateOrgDataDto
   */
  suspended?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceDomainSSLSetupDto
 */
export interface OrgServiceDomainSSLSetupDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceDomainSSLSetupDto
   */
  orgId?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceDomainSSLSetupDto
   */
  tries?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceDomainSSLSetupDto
   */
  lastTryAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceDomainSSLSetupDto
   */
  done?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrgServiceDomainSSLSetupDto
   */
  doneAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceDomainSSLSetupDto
   */
  failed?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceDomainSetupStateDto
 */
export interface OrgServiceDomainSetupStateDto {
  /**
   * One of: done, inprogress, error, none. none set when no domain is specified
   * @type {string}
   * @memberof OrgServiceDomainSetupStateDto
   */
  state?: string;
  /**
   *
   * @type {OrgServiceDomainSSLSetupDto}
   * @memberof OrgServiceDomainSetupStateDto
   */
  domainSslSetup?: OrgServiceDomainSSLSetupDto;
  /**
   *
   * @type {OrgServiceCloudFrontDistributionDto}
   * @memberof OrgServiceDomainSetupStateDto
   */
  cloudfrontDistribution?: OrgServiceCloudFrontDistributionDto;
}
/**
 *
 * @export
 * @interface OrgServiceErrorResponseDto
 */
export interface OrgServiceErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface OrgServiceFeatureDto
 */
export interface OrgServiceFeatureDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceFeatureDto
   */
  orgId?: string;
  /**
   *
   * @type {OrgServiceFeatureEnumDto}
   * @memberof OrgServiceFeatureDto
   */
  feature: OrgServiceFeatureEnumDto;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceFeatureDto
   */
  enabled: boolean;
  /**
   *
   * @type {number}
   * @memberof OrgServiceFeatureDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceFeatureDto
   */
  updatedAt?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OrgServiceFeatureEnumDto = {
  Portals: 'portals',
  PortalsOnly: 'portalsOnly',
  PortalsCreate: 'portalsCreate',
} as const;

export type OrgServiceFeatureEnumDto = (typeof OrgServiceFeatureEnumDto)[keyof typeof OrgServiceFeatureEnumDto];

/**
 *
 * @export
 * @interface OrgServiceGetOrgUserRoleResponseDto
 */
export interface OrgServiceGetOrgUserRoleResponseDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceGetOrgUserRoleResponseDto
   */
  role: string;
}
/**
 *
 * @export
 * @interface OrgServiceInternalErrorResponseDto
 */
export interface OrgServiceInternalErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceInternalErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceInternalErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface OrgServiceInviteDto
 */
export interface OrgServiceInviteDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceInviteDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceInviteDto
   */
  role: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceInviteDto
   */
  addedByUserId: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceInviteDto
   */
  email: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceInviteDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceInviteDto
   */
  updatedAt: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceInviteDto
   */
  used: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgServiceInviteDto
   */
  url?: string;
  usedByUserId?: number | null;
}
/**
 *
 * @export
 * @interface OrgServiceMemberDto
 */
export interface OrgServiceMemberDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceMemberDto
   */
  globalId: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceMemberDto
   */
  orgId: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceMemberDto
   */
  userId: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceMemberDto
   */
  createdAt: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceMemberDto
   */
  updatedAt: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceMemberDto
   */
  role: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceMemberDto
   */
  disabled?: boolean;
  expiresAt?: number | null; // Optional and nullable
  memberTTL?: number | null; // Optional and nullable
}
/**
 *
 * @export
 * @interface OrgServiceNotFoundErrorResponseDto
 */
export interface OrgServiceNotFoundErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceNotFoundErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceNotFoundErrorResponseDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface OrgServiceOrgAutoDomainCreateDataDto
 */
export interface OrgServiceOrgAutoDomainCreateDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainCreateDataDto
   */
  orgId: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainCreateDataDto
   */
  domain: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainCreateDataDto
   */
  defaultRole?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgAutoDomainCreateDataDto
   */
  withNimbus?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceOrgAutoDomainDto
 */
export interface OrgServiceOrgAutoDomainDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainDto
   */
  domain?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgAutoDomainDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgAutoDomainDto
   */
  updatedAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgAutoDomainDto
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgAutoDomainDto
   */
  withNimbus?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceOrgAutoDomainUpdateDataDto
 */
export interface OrgServiceOrgAutoDomainUpdateDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainUpdateDataDto
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgAutoDomainUpdateDataDto
   */
  defaultRole?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgAutoDomainUpdateDataDto
   */
  withNimbus?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceOrgDto
 */
export interface OrgServiceOrgDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  globalId?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgDto
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgDto
   */
  updatedAt?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  sub?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgDto
   */
  maxMembers?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgDto
   */
  suspended?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgDto
   */
  domainShorter?: boolean;
  /**
   * Org type
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgDto
   */
  isOtherDescription?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  authFormText?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgDto
   */
  authFormPrivacyLinkEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgDto
   */
  authAllowRegistration?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  privacyLinkText?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  privacyLinkUrl?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgDto
   */
  orgType?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgDto
   */
  isShareAdEnabled?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceOrgInfoDto
 */
export interface OrgServiceOrgInfoDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgInfoDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgInfoDto
   */
  type?: OrgServiceOrgInfoDtoTypeEnum;
  /**
   * Actual only for private organizations
   * @type {boolean}
   * @memberof OrgServiceOrgInfoDto
   */
  isPremium?: boolean;
  /**
   * Domain on which the organization can be accessed, it is not the same value as org.domain
   * @type {string}
   * @memberof OrgServiceOrgInfoDto
   */
  domain?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgInfoDto
   */
  domainShorter?: boolean;
  /**
   *
   * @type {OrgServiceSubscriptionTypesDto}
   * @memberof OrgServiceOrgInfoDto
   */
  subscriptionType?: OrgServiceSubscriptionTypesDto;
  /**
   *
   * @type {OrgServiceSubscriptionTypesDto}
   * @memberof OrgServiceOrgInfoDto
   */
  subscriptionTypeSrc?: OrgServiceSubscriptionTypesDto;
  /**
   * List of privileges that allowed for subscriptionType, it is not a comprehensive list of all privileges available for the org, but | those that are only available for specific subscription types
   * @type {Array<string>}
   * @memberof OrgServiceOrgInfoDto
   */
  subscriptionPrivileges?: Array<string>;
  /**
   * Whether to show the registration form in shares
   * @type {boolean}
   * @memberof OrgServiceOrgInfoDto
   */
  isShareAdEnabled?: boolean;
}

export const OrgServiceOrgInfoDtoTypeEnum = {
  Private: 'private',
  Business: 'business',
} as const;

export type OrgServiceOrgInfoDtoTypeEnum =
  (typeof OrgServiceOrgInfoDtoTypeEnum)[keyof typeof OrgServiceOrgInfoDtoTypeEnum];

/**
 *
 * @export
 * @interface OrgServiceOrgLimitsDto
 */
export interface OrgServiceOrgLimitsDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  traffic: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  storage?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  workspaces: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  textSize: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  attachmentSize: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  encryptionKeysPerWorkspace: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  membersPerWorkspace: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  membersPerOrg?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  notesPerWorkspace: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  streamingVideosPerMonth?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  ocr?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  blots?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  taskDeadlinesPerWorkspace: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgLimitsDto
   */
  taskRemindersPerWorkspace: number;
}
/**
 *
 * @export
 * @interface OrgServiceOrgNotesDto
 */
export interface OrgServiceOrgNotesDto {
  /**
   * true if more than 0 notes found across all workspaces in org, except welcome notes
   * @type {boolean}
   * @memberof OrgServiceOrgNotesDto
   */
  isNotesFound?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceOrgSmtpDto
 */
export interface OrgServiceOrgSmtpDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  orgId?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  host?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgSmtpDto
   */
  port?: number;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  type?: OrgServiceOrgSmtpDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  login?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  senderEmail?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceOrgSmtpDto
   */
  senderName?: string;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgSmtpDto
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceOrgSmtpDto
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceOrgSmtpDto
   */
  enabled?: boolean;
}

export const OrgServiceOrgSmtpDtoTypeEnum = {
  Ssl: 'ssl',
  Tls: 'tls',
  None: 'none',
} as const;

export type OrgServiceOrgSmtpDtoTypeEnum =
  (typeof OrgServiceOrgSmtpDtoTypeEnum)[keyof typeof OrgServiceOrgSmtpDtoTypeEnum];

/**
 *
 * @export
 * @interface OrgServiceOrgUsageDto
 */
export interface OrgServiceOrgUsageDto {
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  traffic?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  storage?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  workspaces?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  blots?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  clients?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  members?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  guests?: OrgServiceUsageItemDto;
  /**
   *
   * @type {OrgServiceUsageItemDto}
   * @memberof OrgServiceOrgUsageDto
   */
  activepieces?: OrgServiceUsageItemDto;
}
/**
 *
 * @export
 * @interface OrgServicePlanDetailsDto
 */
export interface OrgServicePlanDetailsDto {
  /**
   *
   * @type {OrgServiceSubscriptionTypesDto}
   * @memberof OrgServicePlanDetailsDto
   */
  subscriptionType?: OrgServiceSubscriptionTypesDto;
}
/**
 *
 * @export
 * @interface OrgServiceRedeemCouponDataDto
 */
export interface OrgServiceRedeemCouponDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceRedeemCouponDataDto
   */
  token: string;
}
/**
 *
 * @export
 * @interface OrgServiceSetBillingInfoDataDto
 */
export interface OrgServiceSetBillingInfoDataDto {
  /**
   * Max count of members in the org
   * @type {number}
   * @memberof OrgServiceSetBillingInfoDataDto
   */
  members: number;
  /**
   * Subscription reference from a payment system
   * @type {string}
   * @memberof OrgServiceSetBillingInfoDataDto
   */
  subscriptionId: string;
  /**
   * Subscription plan code
   * @type {string}
   * @memberof OrgServiceSetBillingInfoDataDto
   */
  plan: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OrgServiceSubscriptionTypesDto = {
  Standard: 'standard',
  Business: 'business',
  Premium: 'premium',
  AllInOne: 'allInOne',
  Plus: 'plus',
  Team: 'team',
  Business2023: 'business2023',
} as const;

export type OrgServiceSubscriptionTypesDto =
  (typeof OrgServiceSubscriptionTypesDto)[keyof typeof OrgServiceSubscriptionTypesDto];

/**
 *
 * @export
 * @interface OrgServiceSubscriptionTypesPrivilegesDto
 */
export interface OrgServiceSubscriptionTypesPrivilegesDto {
  /**
   *
   * @type {object}
   * @memberof OrgServiceSubscriptionTypesPrivilegesDto
   */
  plus?: object;
  /**
   *
   * @type {object}
   * @memberof OrgServiceSubscriptionTypesPrivilegesDto
   */
  team?: object;
  /**
   *
   * @type {object}
   * @memberof OrgServiceSubscriptionTypesPrivilegesDto
   */
  business2023?: object;
}
/**
 *
 * @export
 * @interface OrgServiceSuspendDataDto
 */
export interface OrgServiceSuspendDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceSuspendDataDto
   */
  reason: string;
}
/**
 *
 * @export
 * @interface OrgServiceUpdateInviteDataDto
 */
export interface OrgServiceUpdateInviteDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceUpdateInviteDataDto
   */
  role?: string;
}
/**
 *
 * @export
 * @interface OrgServiceUpdateMemberDataDto
 */
export interface OrgServiceUpdateMemberDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceUpdateMemberDataDto
   */
  role?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceUpdateMemberDataDto
   */
  disabled?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceUpdateOrgDataDto
 */
export interface OrgServiceUpdateOrgDataDto {
  /**
   * Org title
   * @type {string}
   * @memberof OrgServiceUpdateOrgDataDto
   */
  title?: string;
  /**
   * Org description
   * @type {string}
   * @memberof OrgServiceUpdateOrgDataDto
   */
  description?: string;
  /**
   * How many people the user wants to collaborate with
   * @type {string}
   * @memberof OrgServiceUpdateOrgDataDto
   */
  peopleToCollaborate?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceUpdateOrgDataDto
   */
  domainShorter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrgServiceUpdateOrgDataDto
   */
  authAllowRegistration?: boolean;
  /**
   * Whether to show the registration form in shares
   * @type {boolean}
   * @memberof OrgServiceUpdateOrgDataDto
   */
  isShareAdEnabled?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceUpdateOrgSmtpDataDto
 */
export interface OrgServiceUpdateOrgSmtpDataDto {
  /**
   * Org globalId
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  orgId?: string;
  /**
   * Smtp hostname
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  host?: string;
  /**
   * Smtp port
   * @type {number}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  port?: number;
  /**
   * Smtp secure type (ssl,tls,none)
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  type?: string;
  /**
   * Smtp login
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  login?: string;
  /**
   * Smtp password
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  password?: string;
  /**
   * Sender email
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  senderEmail?: string;
  /**
   * Name of sender
   * @type {string}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  senderName?: string;
  /**
   * Enable smtp?
   * @type {boolean}
   * @memberof OrgServiceUpdateOrgSmtpDataDto
   */
  enabled?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceUpdateUserDataDto
 */
export interface OrgServiceUpdateUserDataDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceUpdateUserDataDto
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceUpdateUserDataDto
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceUpdateUserDataDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceUpdateUserDataDto
   */
  username?: string;
}
/**
 *
 * @export
 * @interface OrgServiceUsageItemDto
 */
export interface OrgServiceUsageItemDto {
  /**
   *
   * @type {number}
   * @memberof OrgServiceUsageItemDto
   */
  current: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceUsageItemDto
   */
  max: number;
  /**
   *
   * @type {number}
   * @memberof OrgServiceUsageItemDto
   */
  maxHard?: number;
}
/**
 *
 * @export
 * @interface OrgServiceUserOrgRoleDto
 */
export interface OrgServiceUserOrgRoleDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceUserOrgRoleDto
   */
  role?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof OrgServiceUserOrgRoleDto
   */
  privileges?: Array<string>;
  /**
   * This shows that returned privileges are reduced because of the suspension of the organization
   * @type {boolean}
   * @memberof OrgServiceUserOrgRoleDto
   */
  reduced?: boolean;
}
/**
 *
 * @export
 * @interface OrgServiceValidationErrorResponseDto
 */
export interface OrgServiceValidationErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof OrgServiceValidationErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceValidationErrorResponseDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OrgServiceValidationErrorResponseDto
   */
  field: string;
}
